import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { useAuth } from "../../../contexts/AuthContext";

import "./Header.css";

export default function Header() {

    const navigate = useNavigate();

    const { user, logout } = useAuth();

    const [showMenu, setShowMenu] = useState(false);

    const handleLogout = () => {

        logout();

        navigate("/login");

    };

    return (

        <header className="admin-header">

            <div>

                <h4>Dashboard</h4>

                <small>Welcome to Website CMS</small>

            </div>

            <div className="header-right">

                <div className="current-date">

                    {new Date().toLocaleDateString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric"
                    })}

                </div>

                <div className="user-dropdown">

                    <button
                        className="user-btn"
                        onClick={() => setShowMenu(!showMenu)}
                    >

                        <i className="bi bi-person-circle"></i>

                        <span>{user?.fullName}</span>

                        <i className="bi bi-chevron-down"></i>

                    </button>

                    {
                        showMenu &&

                        <div className="dropdown-menu-custom">
                            
                            <button  onClick={() => navigate("/change-password")}>

                                <i className="bi bi-key"></i>

                                Change Password

                            </button>

                            <button onClick={handleLogout}>

                                <i className="bi bi-box-arrow-right"></i>

                                Logout

                            </button>

                        </div>
                    }

                </div>

            </div>

        </header>

    );

}